import { css } from "@emotion/react";

export const overlayCss = css`
  display: flex;
  justify-content: center;
`;

export const modalCss = css`
  margin: 20px auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100vw - 40px);
  max-width: 1400px;
  height: calc(100vh - 40px);
  //max-height: 818px;
  min-height: 543px;
`;

export const modalContentCss = css`
  //background-color: red;
  max-height: 818px;
  padding: 24px;
`;
